import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const WasteTippingMonitor = ({ dataUrl }) => {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProviders();
    }, []);

    const fetchProviders = async () => {
        try {
            const res = await axios.get(dataUrl);
            setProviders(res.data.data || []);
        } catch (err) {
            console.error('Failed to load waste tipping monitor:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <i className="fas fa-spinner fa-spin"></i> Loading waste tipping monitor...
            </div>
        );
    }

    return (
        <>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Provider</th>
                            <th>Outstanding</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {providers.map((provider) => (
                            <tr key={provider.id}>
                                <td>{provider.provider_name}</td>

                                <td>
                                    <strong>{provider.outstanding_jobs}</strong> jobs
                                </td>
                                <td className="text-right">
                                    <a
                                        href={provider.view_url}
                                        className="btn btn-sm btn-primary"
                                    >
                                        View Jobs
                                    </a>
                                </td>
                            </tr>
                        ))}

                        {!providers.length && (
                            <tr>
                                <td colSpan="6" className="text-center text-muted">
                                    No outstanding waste tipping jobs.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default WasteTippingMonitor;
const el = document.getElementById('wasteTippingMonitor');

if (el) {
    ReactDOM.render(
        <WasteTippingMonitor dataUrl={el.dataset.dataUrl} />,
        el
    );
}